<template>
  <div>
    <homePage></homePage>
  </div>
</template>

<script>
  import { getDifferentSiteNameInList } from '@/common/js/siteUtil.js'
  const differentSiteList = ['betl', 'b027site', 'b027sport']
  const siteName = getDifferentSiteNameInList(differentSiteList)
  const homePage = () => import(`@/components/different/${siteName}/home/home.vue`)
  export default {
    name: 'home',
    components: {
      homePage
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/home.vue